import Footer from "../components/footer/footer.component";
import Navbar from "../components/navbar/navbar.component";
import About from "../pages/about/about";
import CaseStudy from "../pages/case-study/case-study.component";
import Home from "../pages/home/home";

function Landing() {
  return (
    <div className="col-12">
      <div className="navigation-bar-container px-3">
        <Navbar />
      </div>
      <Home />
      <CaseStudy />
      <About />
      <div className="footer-container">
        <Footer />
      </div>
    </div>
  );
}

export default Landing;
